import { twMerge } from "tailwind-merge";

type ClassValue = string | boolean | undefined | null;

export function cn(...inputs: ClassValue[]) {
  return twMerge(inputs.filter(Boolean).join(" "));
}
